// frontend/src/main.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import App from "./App";
import "./index.css";
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "./context/AuthProvider";
import CreditProvider from "./context/CreditProvider";
import { initDarkMode } from "./lib/darkMode";

// Initialize dark mode before rendering
initDarkMode();

// Create router
const router = createBrowserRouter([
  {
    path: "/*",
    element: <App />,
    errorElement: (
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="text-center space-y-4">
          <h1 className="text-2xl font-bold text-red-600 dark:text-red-400">
            Oops! Something went wrong
          </h1>
          <p className="text-slate-600 dark:text-slate-400">
            Please refresh the page or contact support if the problem persists.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Reload Page
          </button>
        </div>
      </div>
    ),
  },
]);

// Get root element
const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found. Check your index.html file.");
}

// Render app
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <HelmetProvider>
      <AuthProvider>
        <CreditProvider>
          {/* Toast notifications with custom styling */}
          <Toaster
            position="top-center"
            toastOptions={{
              // Default options
              duration: 4000,
              style: {
                background: "var(--toast-bg)",
                color: "var(--toast-text)",
                border: "1px solid var(--toast-border)",
                borderRadius: "0.5rem",
                padding: "12px 16px",
              },
              // Success
              success: {
                duration: 3000,
                iconTheme: {
                  primary: "#10b981",
                  secondary: "#fff",
                },
              },
              // Error
              error: {
                duration: 5000,
                iconTheme: {
                  primary: "#ef4444",
                  secondary: "#fff",
                },
              },
              // Loading
              loading: {
                iconTheme: {
                  primary: "#3b82f6",
                  secondary: "#fff",
                },
              },
            }}
          />
          <RouterProvider router={router} />
        </CreditProvider>
      </AuthProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// Optional: Log app initialization
if (import.meta.env.DEV) {
  console.log("🚀 AutoQuiz AI initialized in development mode");
}

// Optional: Register service worker for PWA (if you have one)
// Temporarily disabled while debugging signed video URL loading.
// if ("serviceWorker" in navigator && import.meta.env.PROD) {
//   window.addEventListener("load", () => {
//     navigator.serviceWorker
//       .register("/sw.js")
//       .then(() => console.log("✓ Service Worker registered"))
//       .catch(() => console.log("✗ Service Worker registration failed"));
//   });
// }



